// This registry only contains hand-crafted templates for special cases.
import { LogMessageRegistry } from './log-message-registry.model'
import { userLogGenerators } from './user-log-generators'

// Everything else will use the smartDefaultGenerator.
export const LOG_MESSAGE_REGISTRY: LogMessageRegistry = {
  ...userLogGenerators
}
